import { render, staticRenderFns } from "./ExerciseTest.vue?vue&type=template&id=9329131a"
import script from "./ExerciseTest.vue?vue&type=script&lang=js"
export * from "./ExerciseTest.vue?vue&type=script&lang=js"
import style0 from "./ExerciseTest.vue?vue&type=style&index=0&id=9329131a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports